import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';

import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link.tsx';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { FieldHeadingIconsVisibility } from '@atlassian/jira-issue-field-heading/src/styled.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DummySectionHeading = styled(FieldHeadingIconsVisibility)({
	display: 'flex',
	alignItems: 'center',
	flexWrap: 'nowrap',
	gap: `0 ${token('space.100')}`,
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InfoButton = styled(Button)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	lineHeight: `${3 * gridSize}px`,
	width: '24px',
	height: '24px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TryLozenge = styled(Lozenge)({
	marginLeft: `${token('space.050')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledLink = styled(Link)({
	textDecoration: 'none',
	'&:focus, &:hover, &:visited, &:link, &:active': {
		textDecoration: 'none',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RightWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: `0 ${token('space.100')}`,
	justifyContent: 'space-between',

	color: token('color.text'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LeftWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: `0 ${token('space.100')}`,
	justifyContent: 'space-between',

	color: token('color.text'),
	minWidth: 0,
});

// 1px padding to the right to be aligned with the add comment box because of the shadow around it
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DummyGroupContainer = styled.div({
	marginTop: token('space.100'),
	marginRight: 0,
	marginBottom: token('space.100'),
	marginLeft: 0,
	paddingRight: token('space.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CardWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:last-child': {
		borderBottomColor: 'transparent',
	},
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		backgroundColor: token('color.background.neutral.subtle.hovered'),
		textDecoration: 'none',
		cursor: 'pointer',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderBottom: `1px solid ${token('color.border')}`,
	boxShadow: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.neutral.subtle'),
	paddingTop: 0,
	paddingRight: token('space.075'),
	paddingBottom: 0,
	paddingLeft: token('space.075'),
	marginTop: 0,
	marginRight: token('space.025'),
	marginBottom: 0,
	marginLeft: token('space.025'),
	borderRadius: '3px',
	display: 'flex',
	minHeight: '40px',
	justifyContent: 'space-between',
	alignItems: 'center',
	alignSelf: 'stretch',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledTemplateName = styled.p({
	marginTop: token('space.0'),
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});
